<template>
  <div class="vote-overview-container">
    <div :class="gridClass">
      <template v-for="voteItem in voteItems">
        <div
          v-if="voteItem.type === 'divider'"
          :key="`${voteItem.id}-divider`"
          class="lg:col-span-full vote-item-divider"
        >
          <div
            class="vote-item-divider-title"
            :style="{ 'background-color': partyColor }"
          >
            <span>
              {{ voteItem.label }}
            </span>
          </div>
          <div class="vote-item-separator separator"></div>
        </div>
        <vote-item
          v-else
          :key="voteItem.id"
          :voteItem="voteItem"
          :candidateId="candidateId"
          :user-vote="userVotes[voteItem.id]"
          :show-pin="showPin"
          :pinned-color="pinnedVotes[voteItem.id]?.color"
          :id="`vote-item-${voteItem.id}`"
          @pinned="$emit('pinned', voteItem.id)"
          @text-click="goToAffair(voteItem)"
        />
      </template>
    </div>
  </div>
</template>
<script>
import VoteItem from "./VoteItem.vue";

export default {
  name: "VoteOverview",
  props: {
    voteItems: {
      type: Array,
      required: true
    },
    pinnedVotes: {
      type: Object,
      default: () => ({})
    },
    showPin: {
      type: Boolean,
      default: false
    },
    partyColor: {
      type: String
    },
    candidateId: {
      type: Number
    },
    userVotes: {
      type: Object,
      default: () => ({})
    },
    gridClass: {
      type: String,
      default: "grid grid-cols-1 lg:grid-cols-3 gap-2 items-stretch"
    }
  },
  components: {
    VoteItem
  },
  mounted() {
    if (this.$route.hash) {
      this.$nextTick(() => {
        const selectedVote = document.querySelector(this.$route.hash);
        if (selectedVote) {
          return selectedVote.scrollIntoView({ behavior: "auto" });
        }
      });
    }
  },
  computed: {
    monthNames() {
      return [
        this.$t("components.dates.month_January"),
        this.$t("components.dates.month_February"),
        this.$t("components.dates.month_March"),
        this.$t("components.dates.month_April"),
        this.$t("components.dates.month_May"),
        this.$t("components.dates.month_June"),
        this.$t("components.dates.month_July"),
        this.$t("components.dates.month_August"),
        this.$t("components.dates.month_September"),
        this.$t("components.dates.month_October"),
        this.$t("components.dates.month_November"),
        this.$t("components.dates.month_December")
      ];
    }
  },
  methods: {
    goToAffair(voteItem) {
      this.$router
        .replace({
          ...this.$route,
          hash: `#vote-item-${voteItem.id}`
        })
        .finally(() => {
          this.$router.push({
            name: "affair",
            query: {
              voteId: voteItem.id
            },
            params: {
              id: voteItem.affair.id
            }
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.vote-item-divider {
  position: relative;
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;
}
.vote-item-divider-title {
  position: relative;
  margin: auto;
  display: flex;
  align-items: center;
  background: var(--color-candidate);
  color: white;
  height: 2rem;
  width: 80%;
  border-radius: 1rem;
  font-weight: bold;
  z-index: 1;
}
.vote-item-divider-title span {
  margin: auto;
}
.vote-item-separator {
  position: absolute;
  top: 1rem;
  width: 150%;
  margin-left: -25%;
  background-color: var(--color-divider);
  z-index: 0;
}
</style>
